<template>
  <div class="dashboard-screen">
    <div
      v-if="!hideHeader"
      class="dashboard-screen__head"
    >
      <h1 class="dashboard-screen__title">
        {{ screen.title }}
      </h1>
      <p
        v-if="screen.description"
        class="dashboard-screen__description"
      >
        {{ screen.description }}
      </p>
    </div>
    <DashboardNodeRenderer
      v-for="(section, index) in screen.sections"
      :key="section.id || index"
      :node="section"
      @row-detail="$emit('row-detail', $event)"
      @input="$emit('input', $event)"
      @filter-change="$emit('filter-change', $event)"
      @update:options="$emit('update:options', $event)"
      @submit="$emit('submit', $event)"
    />
  </div>
</template>

<script>
import DashboardNodeRenderer from './DashboardNodeRenderer.vue'

export default {
  name: 'DashboardScreen',
  components: { DashboardNodeRenderer },
  props: {
    screen: {
      type: Object,
      required: true
    },
    hideHeader: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss">
.dashboard-screen {
  &__head {
    margin-bottom: 24px;
  }

  &__title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--custom-theme-black-054);
    margin-bottom: 6px;
  }

  &__description {
    font-size: 0.875rem;
    color: var(--ds-color-black-055);
    max-width: 680px;
  }
}
</style>
